module.exports = __webpack_public_path__ + "static/nexus.38a2f659.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/nexus.jpg
// module id = 358
// module chunks = 35783957827783